module.exports = __webpack_public_path__ + "media/images/patient-icons/trash-icon-83d3c25956b1fbba99d3e27240df37fa.svg";